import request from '@/config'
import { useAppStoreWithOut } from '@/store/app'
import { PlanSearch, PlanCreate, PlanEditor, PayTypeSearch, PayplanSubmitDto } from './payplan.type'

enum Apis {
    CacluateAmount = `/api/payplan/calculatepayplanamount`,
}

/* 付款计划：列表(List) */
export const CacluateAmountApi = (ctAmount: number, planAmount: number): Promise<IResponse> =>
    request.post({
        url: Apis.CacluateAmount,
        data: { contract_amount: ctAmount, plan_amount: planAmount }
    });

const appStore = useAppStoreWithOut()

/* 付款计划：列表(List) */
export const PayPlanListApi = (search: PlanSearch): Promise<IResponse> => {
    return request.post({ url: '/api/payplan/getpayplanpage', data: search })
}

/* 付款计划：明细(Detail) */
export const PayPlanDetailApi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: '/api/payplan/getpayplaninfo', data: { id: rowId } })

}

/* 付款申请：附件(Material) */
export const BillMaterialApi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: '/api/payplan/getbillmateriallist', data: { id: rowId } })

}

/* 付款申请：修改付款申请数据 */
export const BillUpdate = (subData: PayplanSubmitDto): Promise<IResponse> => {

    return request.post({ url: '/api/payplan/updatepayplanbilldetail', data: subData})

}



/* 付款计划：删除(Delete) */
export const PayPlanDeleteApi = (rowId: string, revision: string): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const deleteDto: DeleteDto = {
        deleted_user_id: login.user_id,
        revision: revision,
        id: rowId,
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id
    }

    return request.post({ url: 'api/payplan/deletepayplan', data: deleteDto })
}

/* 付款计划：新增(Create) */
export const CreatePlanApi = (createDto: PlanCreate): Promise<IResponse> => {
    return request.post({ url: 'api/payplan/insertpayplan', data: createDto })
}

/* 付款计划：修改(Editor) */
export const PlanApi = (editDto: PlanEditor): Promise<IResponse> => {
    return request.post({ url: 'api/payplan/updatepayplan', data: editDto })
}


/* 付款类型：列表（LIST） */
export const PayTypeListApi = (search: PayTypeSearch): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const searchDto = {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
        current: 1,
        page_size: 99,
    }

    search = Object.assign({}, search, searchDto)

    return request.post({ url: '/api/paycondition/getpayconditionpage', data: search })
}

/* 付款类型：提交（Submit) */
export const SubPayPlanApi = (subData: PayplanSubmitDto): Promise<IResponse> => {

    return request.post({ url: '/api/payplan/submitpayplan', data: subData })

}


/* 获取合同付款记录 */
export const GetBillListApi = (ctId: string): Promise<IResponse> => {

    return request.post({ url: '/api/payplan/getbilllist', data: { contract_id: ctId } })

}

/* 合同履约情况数据统计(金额) */
export const PlanPerformTotalApi = (ctId: string): Promise<IResponse> => {

    return request.post({ url: '/api/payplan/getplanperforminfo', data: { id: ctId } })

}

/* 获取付款计划对应的所有费用申请 */
export const GetFeeBillsApi = (planId: string): Promise<IResponse> => {

    return request.post({ url: 'api/payplan/getfeebills', data: { id: planId}} )
}

/* 提交补发票申请 */
export const SubmitReimburseApi = (subData: PayplanSubmitDto): Promise<IResponse> => {
    return request.post({ url: 'api/payplan/submitreimburse', data: subData } )
}


/* 获取所有含费用申请的付款计划 */
export const GetFeePayplanListApi = (): Promise<IResponse> => {
    return request.post({ url:'api/payplan/getfeepayplanlist' })
} 